/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day of month`)
};

const es_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Día del mes`)
};

const de_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag des Monats`)
};

const nl_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dag van de maand`)
};

const fr_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jour du mois`)
};

const it_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorno del mese`)
};

const pt_br2_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia do mês`)
};

const pt_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia do mês`)
};

const ja_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日（月内）`)
};

const zh_cr_f_dom = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_f_dom = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_f_dom(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_f_dom", locale)
	if (locale === "en") return en_cr_f_dom(inputs)
	if (locale === "es") return es_cr_f_dom(inputs)
	if (locale === "de") return de_cr_f_dom(inputs)
	if (locale === "nl") return nl_cr_f_dom(inputs)
	if (locale === "fr") return fr_cr_f_dom(inputs)
	if (locale === "it") return it_cr_f_dom(inputs)
	if (locale === "pt-BR") return pt_br2_cr_f_dom(inputs)
	if (locale === "pt") return pt_cr_f_dom(inputs)
	if (locale === "ja") return ja_cr_f_dom(inputs)
	return zh_cr_f_dom(inputs)
};